import "./Tittles.css"

function Tittles({ tittle }) {
	return (
		<h2>
			<span className="typing-text">{tittle}</span>
		</h2>
	)
}

export default Tittles
